<template>
  <form
    v-loading="loading"
    @submit.prevent="save"
  >
    <b-modal
      ref="modal"
      :visible="true"
      :title="title"
      @hide="close"
    >
      <div class="form-group">
        <label>{{ $t('Email') }}</label>
        <input
          v-model="model.email"
          type="email"
          class="form-control"
          required
        >
      </div>
      <div class="form-group">
        <label>{{ $t('New password') }}</label>
        <input
          v-model="model.password"
          type="text"
          class="form-control"
          minlength="6"
        >
      </div>
      <div class="form-group">
        <label>{{ $t('First name') }}</label>
        <input
          v-model="model.firstName"
          type="text"
          class="form-control"
          required
          minlength="3"
        >
      </div>
      <div class="form-group">
        <label>{{ $t('Last name') }}</label>
        <input
          v-model="model.lastName"
          type="text"
          class="form-control"
          required
          minlength="3"
        >
      </div>
      <div class="form-group">
        <input
          id="account-create-form-admin"
          v-model="model.isAdmin"
          type="checkbox"
        >
        <label for="account-create-form-admin">{{ $tc('Admins', 1) }}?</label>
      </div>
      <div class="form-group">
        <input
          id="account-create-form-enabled"
          v-model="model.enabled"
          type="checkbox"
        >
        <label for="account-create-form-enabled">{{ $t('Active') }}?</label>
      </div>
      <template slot="modal-footer">
        <button
          type="submit"
          class="btn btn-primary"
        >
          {{ $t('Save') }}
        </button>
        <button
          type="button"
          class="btn btn-secondary"
          @click.prevent="close"
        >
          {{ $t('Close') }}
        </button>
      </template>
    </b-modal>
  </form>
</template>

<script>
import UserModel from '../models/UserModel';
import UserService from '../services/UsersService';

export default {
  name: 'AppPageUsersCreate',
  data() {
    return {
      model: UserModel.getDefaults(),
      loading: true,
    };
  },
  computed: {
    title() {
      if (this.model.id === 0) {
        return this.$t('Loading');
      }
      return `${this.$tc('Users', 1)} ID: ${this.model.id}`;
    },
    userId() {
      return parseInt(this.$route.params.id, 10);
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      UserService.findById(this.userId).then(data => {
        this.model = UserModel.fromApiResponse(data);
        this.loading = false;
      }).catch(() => {
        this.$errors_showNetworkErrorMessage();
        this.close();
      });
    },
    save() {
      this.loading = true;
      const data = UserModel.toApiRequest(this.model);
      UserService.update(this.userId, data).then(() => {
        this.$toastr.success(this.$t('Action', { object: this.$tc('Users', 1), action: this.$t('updated') }), this.$t('Success'));
        this.loading = false;
      }).catch(error => {
        this.$toastr.error(error.message, this.$t('Error'));
        this.loading = false;
      });
    },
    close() {
      this.$router.back();
    },
  },
};
</script>
